import { render, staticRenderFns } from "./chartPie.pug?vue&type=template&id=b50f837e&lang=pug&"
import script from "./chartPie.js?vue&type=script&lang=js&"
export * from "./chartPie.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b50f837e')) {
      api.createRecord('b50f837e', component.options)
    } else {
      api.reload('b50f837e', component.options)
    }
    module.hot.accept("./chartPie.pug?vue&type=template&id=b50f837e&lang=pug&", function () {
      api.rerender('b50f837e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminLayout/views/charts/components/chartPie/index.vue"
export default component.exports